<template>
    <div class="row mb-5 justify-content-center">
        <div :class="[`col-lg-${lgCount}`, 'mt-lg-4', 'mt-2']" v-for="(item, index) in subscriptions" :key="index">
            <SubscriptionItem
                    :subscription="item"
                    :active="activeSubscriptions[index]"
                    :orderTitle="orderTitle"
                    @selected="selected"
                    @order="order"
                    @bonusCourseClick="bonusCourseClick"
            />
        </div>
    </div>
</template>

<script>
    import SubscriptionItem from "./SubscriptionItem";
    import i18n from './../../i18n';

    export default {
        name: "SubscriptionsList",
        components: {SubscriptionItem},
        props: {
            subscriptions: {type: Array, default: () => []},
            orderTitle: {type: String, default: i18n.t('sign_up')},
            lgCount: {type: Number, default: 3}
        },

        data() {
            return {
                activeSubscriptions: [true],
            }
        },

        mounted() {

        },

        methods: {
            selected(subscription) {
                this.$emit("selected", subscription);
                this.setActive(subscription)
            },

            order(subscription) {
                this.$emit("order", subscription);
                this.setActive(subscription)
            },

            bonusCourseClick(subscription) {
                this.$emit("bonusCourseClick", subscription);
            },

            setActive(subscription) {
                this.activeSubscriptions = []
                let index = 0;
                for (let sub of this.subscriptions) {
                    this.activeSubscriptions[index] = subscription.idsubscription === sub.idsubscription
                    index++;
                }
            }

        },

        watch: {
            subscriptions(subs) {
                if (subs) {
                    //Если ни одна пописка не активна, делаем активной первую
                    let activeCount = 0;
                    for (let sub of subs) {
                        if (sub.active) activeCount++;
                    }
                    if (activeCount === 0 && subs.length > 0) subs[0].active = true
                }
            }
        }
    }
</script>

<style scoped>

</style>
